import { useEffect, useRef } from 'react';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import useNavigateWithEnv from './useNavigateWithEnv';

export const shouldExitOnEnvChange = (
  prevEnvId: string | undefined,
  currentEnvId: string | undefined,
): boolean => !!prevEnvId && !!currentEnvId && prevEnvId !== currentEnvId;

const useExitOnEnvChange = (basePath: string) => {
  const selectedEnvId = useSelectedEnv();
  const navigate = useNavigateWithEnv();
  const prevEnvId = useRef(selectedEnvId);

  useEffect(() => {
    if (shouldExitOnEnvChange(prevEnvId.current, selectedEnvId)) {
      navigate(basePath, { replace: true });
    }
    prevEnvId.current = selectedEnvId;
  }, [selectedEnvId, basePath, navigate]);
};

export default useExitOnEnvChange;
